// Event types with dynamic themes per type
export const EVENT_TYPES = [
  { value: "birthday", label: "Birthday" },
  { value: "wedding", label: "Wedding" },
  { value: "baby_shower", label: "Baby Shower" },
  { value: "corporate", label: "Corporate" },
  { value: "graduation", label: "Graduation" },
  { value: "anniversary", label: "Anniversary" },
  { value: "housewarming", label: "Housewarming" },
  { value: "dinner_party", label: "Dinner Party" },
  { value: "custom", label: "Custom" },
];

export const THEMES_BY_TYPE = {
  birthday: ["Elegant", "Playful", "Disco / 70s", "Black Tie", "Tropical", "Pastel Dream", "Neon Nights", "Vintage", "Other"],
  wedding: ["Romantic Garden", "Rustic Barn", "Beachside", "Modern Minimalist", "Vintage", "Bohemian", "Black Tie", "Other"],
  baby_shower: ["Safari Friends", "It's a Boy", "It's a Girl", "Woodland", "Floral", "Pastel Dream", "Storybook", "Other"],
  corporate: ["Modern Minimalist", "Black Tie", "Elegant", "Creative Studio", "Tech Futurist", "Other"],
  graduation: ["Classic Elegant", "Playful", "Modern Minimalist", "Celebratory Gold", "Other"],
  anniversary: ["Romantic", "Black Tie", "Vintage", "Intimate Dinner", "Other"],
  housewarming: ["Cozy Casual", "Modern Minimalist", "Bohemian", "Garden Party", "Other"],
  dinner_party: ["Candlelit", "Trattoria Night", "Omakase", "Wine & Cheese", "Garden Table", "Other"],
  custom: ["Elegant", "Playful", "Minimalist", "Vintage", "Tropical", "Festive", "Modern", "Romantic", "Other"],
};

export const PALETTES = [
  { name: "Classic Monochrome", primary: "#1A1A1A", bg: "#FBF9F4", accent: "#C9A96A" },
  { name: "Emerald Elegance", primary: "#064E3B", bg: "#F4F7F6", accent: "#B4884D" },
  { name: "Midnight Velvet", primary: "#1E293B", bg: "#F8FAFC", accent: "#9B7B4E" },
  { name: "Warm Terracotta", primary: "#9A3412", bg: "#FFF7ED", accent: "#1A1A1A" },
  { name: "Dusty Rose", primary: "#9F1239", bg: "#FFF1F2", accent: "#1A1A1A" },
  { name: "Sand & Ink", primary: "#292524", bg: "#F5F1E8", accent: "#8B6F47" },
  { name: "Ocean Mist", primary: "#0C4A6E", bg: "#F0F9FF", accent: "#B4884D" },
  { name: "Plum Noir", primary: "#3B0764", bg: "#FAF5FF", accent: "#C9A96A" },
];

export function surpriseMe(eventType) {
  const themes = THEMES_BY_TYPE[eventType] || THEMES_BY_TYPE.custom;
  const availableThemes = themes.filter(t => t !== "Other");
  return {
    theme: availableThemes[Math.floor(Math.random() * availableThemes.length)],
    palette: PALETTES[Math.floor(Math.random() * PALETTES.length)].name,
  };
}
